import Vue from 'vue';
import {Flag} from '../models/flag';

const state = () => ({
   flags: [],
   shouldFetchFlags: false,
});

const getters = {
   flags: (state) => Object.values(state.flags),
   shouldFetchFlags: (state) => state.shouldFetchFlags,
   userFlags: (state, getters) => (userId) => {
      return getters.flags.filter((flag) => flag.userId == userId);
   },
   periodFlags: (state, getters) => (lower, upper) => {
      return getters.flags.filter(
         (flag) => flag.period.lower === lower && flag.period.upper === upper
      );
   },
};

const mutations = {
   clear: (state) => {
      state.flags = [];
   },
   setFlags: (state, {flags}) => {
      flags.forEach((flag) => {
         Vue.set(state.flags, flag.id, flag);
      });
   },
   clearShouldFetchFlags: (state) => {
      Vue.set(state, 'shouldFetchFlags', false);
   },
   setShouldFetchFlags: (state) => {
      Vue.set(state, 'shouldFetchFlags', true);
   },
};

/**
 * Shared function to fetch company flags without committing them to the store.
 */
async function requestFlags(http, {companyId, checkSection, period, studyId}) {
   const params = {};
   if (checkSection) {
      params['rule_name'] = checkSection;
   }
   if (period) {
      params['period_lower'] = period[0];
      params['period_upper'] = period[1];
   }
   if (studyId) {
      params['study_id'] = studyId;
   }
   return (await http.get(`/api/company/${companyId}/datacheckflags`, {params})).data;
}

const actions = {
   async loadFlags({commit}, {companyId, checkSection, period, studyId}) {
      const flags = await requestFlags(this._vm.$http, {
         companyId,
         checkSection,
         period,
         studyId,
      });
      commit('clear');
      commit('setShouldFetchFlags');
      commit('setFlags', {flags: flags.map((flag) => new Flag(flag))});
   },

   // Fetch the flags without committing to the store
   async fetchFlags({commit}, {companyId, checkSection, period, studyId}) {
      const response = await requestFlags(this._vm.$http, {
         companyId,
         checkSection,
         period,
         studyId,
      });
      commit('clearShouldFetchFlags');
      return response;
   },

   async verifyFlags({commit}, {companyId, flagIds}) {
      const response = (
         await this._vm.$http.put(`/api/company/${companyId}/datacheckflags/verify`, {
            verified: true,
            ids: flagIds,
         })
      ).data;
      commit('setShouldFetchFlags');
      return response;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
